import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M10.204 9.62c.06-.163.512-.87 1.785-.87.307 0 .684.128 1.025.38.34.25.585.578.684.906.093.306.074.641-.165 1.003-.253.383-.788.845-1.826 1.266a.75.75 0 0 0 .564 1.39c1.203-.488 2.036-1.106 2.514-1.83.493-.747.567-1.548.348-2.265-.21-.694-.682-1.275-1.229-1.678-.546-.402-1.227-.672-1.915-.672-1.913 0-2.921 1.111-3.194 1.856a.75.75 0 0 0 1.41.515ZM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorHelp;
